/**
 * Toggle's the submenu when the user clicks on a parent menu link item,
 * when clicking somewhere else it hides the submenu again.
 */
const menuInit = () => {
  const body = document.getElementsByTagName('body')[0];
  const dropdowns = document.querySelectorAll('.menu .menu__item--has-children, .menu .menu__item--submenu--has-children');
  const headerMenu: HTMLElement = document.querySelector('.header__menu');
  const headerNav: HTMLElement = document.querySelector('.header__navigation');
  const backString = headerMenu.dataset.back;
  const toggler: HTMLElement = document.querySelector('.header__toggler');
  const desktopMenuAll: NodeListOf<HTMLElement> = document.querySelectorAll('.submenu__list');

  const submenuActive = 'submenu__list--active';
  const submenuHidden = 'submenu__list--hidden';

  // Functions
  const toggleSubmenu = (item) => {
    const submenu: HTMLElement = item.querySelector('.submenu__list');
    submenu.classList.toggle(submenuActive);
    item.classList.toggle('menu__item--active');

    // Check if item has closest submenu
    const closestSubmenu = item.closest('.submenu__list');
    if (closestSubmenu) {
      closestSubmenu.scrollTop = 0;
      closestSubmenu.classList.toggle(submenuHidden);
    }
  };

  const submenuHtml = (item) => {
    const menuLink = item.querySelector('.menu__link');
    const title = menuLink.innerHTML;
    const submenu: HTMLElement = item.querySelector('.submenu__list');

    // Prepend title to the submenu
    const titleElement = document.createElement('h3');
    titleElement.innerHTML = title;
    titleElement.classList.add('menu__title');
    submenu.insertAdjacentElement('afterbegin', titleElement);

    // Prepend the back button to the submenu
    const backElement = document.createElement('span');
    backElement.innerHTML = backString;
    backElement.classList.add('menu__back');
    submenu.insertAdjacentElement('afterbegin', backElement);

    // Create back elements
    backElement.addEventListener('click', () => {
      // Close the current submenu
      toggleSubmenu(item);
    });
  };

  // Toggle the menu
  const toggleMenu = () => {
    headerNav.classList.toggle('header__navigation--active');
    toggler.classList.toggle('header__toggler--active');
    body.classList.toggle('overflow-hidden');
  };

  const closeAllMenus = () => {
    [...desktopMenuAll].forEach((menu) => {
      menu.classList.remove('submenu__list--active');
    });
  };

  const removeActiveItems = () => {
    [...dropdowns].forEach((menuItem) => {
      menuItem.classList.remove('menu__item--active');
    });
  };

  // Click on the toggle button top toggle the menu
  if (toggler) {
    toggler.addEventListener('click', () => {
      toggleMenu();
    });
  }

  // Loop through the dropdowns
  [...dropdowns].forEach((menuItem) => {
    // Build the extra html on the submenu
    submenuHtml(menuItem);

    // If the menuItem has been clicked, prevent the menu from being redirected;
    const menuLink = menuItem.querySelector('.menu__link');
    menuLink.addEventListener('click', (event) => {
      event.preventDefault();

      if (menuLink.closest('.menu--desktop')) {
        closeAllMenus();
      }

      // Open the submenu
      if (menuItem.classList.contains('menu__item--active')) {
        menuItem.classList.remove('menu__item--active');
      } else {
        removeActiveItems();
        toggleSubmenu(menuItem);
      }
    });
  });

  document.addEventListener('click', (event: any) => {
    const headerElement = document.querySelector('.header') as HTMLElement;
    const isClickInside = headerElement.contains(event.target);

    if (!isClickInside) {
      closeAllMenus();
      removeActiveItems();
    }
  });

  window.addEventListener('scroll', () => {
    closeAllMenus();
    removeActiveItems();
  });

  // Desktop menu
  const setOverlayPosition = () => {
    const desktopMenu = document.querySelector('.submenu__list');
    const desktopMenuPosition = desktopMenu.getBoundingClientRect();
    const bodyWidth = document.body.clientWidth;
    const desktopRightPostion = bodyWidth - (desktopMenuPosition.x + desktopMenuPosition.width);

    [...desktopMenuAll].forEach((menuItem) => {
      // Update css variable
      menuItem.style.setProperty('--desktopOverlay', `-${desktopRightPostion}px`);
    });
  };

  setOverlayPosition();

  window.addEventListener('resize', () => {
    setOverlayPosition();
  });

  // lower the header opacity when scrolling down, back up when scrolling up
  const header: HTMLElement = document.querySelector('.header');
  let lastScrollTop = 0;

  if (body.offsetWidth > 991) {
    window.addEventListener(
      'scroll',
      () => {
        const newScrollTop = document.documentElement.scrollTop;
        if (newScrollTop > lastScrollTop) {
          header.style.top = '-170px';
          header.style.boxShadow = 'none';
        } else if (newScrollTop < lastScrollTop) {
          header.style.top = '0';
          header.style.boxShadow = '0 5px 30px -2px rgba(0, 0, 0, .2)';
        }
        lastScrollTop = newScrollTop <= 0 ? 0 : newScrollTop;
      },
      false
    );
  }
};

export default menuInit;
